/**
 * Ad slice (SCRUM-1952, RTK bundle 3) — the former switch reducer adReducer.js
 * as createSlice. Behaviour-preserving: every case answers the same legacy
 * action type string (adTypes.js) that adActions.js already dispatches, and
 * returns the same state. The actions module is unchanged, so deleteAd keeps
 * its resolve/reject contract (SCRUM-1944's success toast relies on it) and no
 * importer changes. `CLEAR_MESSAGE` is the same string blog and designs answer
 * to; each slice clears its own message, as the switch reducers did.
 * Characterised by tests/integration/reducers/contentReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { CLEAR_MESSAGE, ADD_AD, GET_ADS, UPDATE_ADD } from "./adTypes";
import type { MessageResponse } from "../../../../shared/apiTypes";

type AdState = {
  message: string;
  ads: any[];
};

const initialState: AdState = {
  message: "",
  ads: [],
};

const adSlice = createSlice({
  name: "ad",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CLEAR_MESSAGE, (state) => ({ ...state, message: "" }))
      .addCase(ADD_AD, (state, action: PayloadAction<MessageResponse, typeof ADD_AD>) => ({ ...state, message: action.payload.msg }))
      .addCase(UPDATE_ADD, (state, action: PayloadAction<MessageResponse, typeof UPDATE_ADD>) => ({ ...state, message: action.payload.msg }))
      .addCase(GET_ADS, (state, action: PayloadAction<AdState["ads"], typeof GET_ADS>) => ({ ...state, ads: action.payload }));
  },
});

export default adSlice.reducer;
